import { CommonModule } from '@angular/common';
import {
  Component,
  HostListener,
  OnInit,
  OnDestroy,
  computed,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { NavigationEnd, RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { AuthorizationService } from '../../../shared/services/authorization.service';
import { requestforEmulationPayload } from '../../../shared/models/model';
import { HeaderService } from '../../../shared/services/header.service';
import { FormsModule } from '@angular/forms';
import { CommonDataService } from '../../../shared/services/common-data.service';
import { filter, Subscription } from 'rxjs';
import config from '../../../../assets/config.json';
import OidcConfig from '../../../../assets/oidc-config.json';
import { EmulationService } from '../../../shared/services/emulation.service';
import { switchAdvisorService } from '../../../shared/services/switchAdvisorService';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  private MFALoginKeyName = config.MFALoginKeyName;
  public isMenuCollapsed = false;
  public isMenuCollapsedForResuorces = false;
  public isMenuCollapsedForProfile = false;
  public isSearchBarOpened = false;
  public isHamburgerMenuIconclicked = false;
  public is_active: string = '';
  public curentDomin: string = window.location.origin.includes('localhost') ? config.siteUrl : window.location.origin;
  public linksResources: any[] = []; // Array to hold the resources links
  public linksTools: any[] = []; // Array to hold the tools links
  public userName: string = '';
  public userInfo: any; // Added to fix Property 'userInfo' does not exist
  private oidcUser: any;
  inputText: string = '';
  advisorList: any = {};

  @ViewChild('inputSearchField_small') inputSearchField_small: ElementRef | undefined;
  @ViewChild('inputSearchField') inputSearchField: ElementRef | undefined;
  @ViewChild('switchAdvisorDisplayer') switchAdvisorDisplayer: ElementRef | undefined;

  windowIsSmall: boolean = false;
  windowIsLarge: boolean = false;
  public authCompletedSubscription: Subscription = new Subscription();
  private navigationSubscription: Subscription = new Subscription();
  emulatedUser = computed(() => this._emulationService.emulatedUser());
  switchedAdvisor = computed(() => this._switchAdvisor.switchedAdvisor());
  accessDelegation: boolean = false; // Flag to control access to the Delegation header
  currentUserId: string = ''; // Variable to hold the current user ID
  loginCheck: boolean = false; // Flag to check if the current page is MFA related
  constructor(
    private _router: Router,
    public _authorize: AuthorizationService,
    private _headerService: HeaderService,
    private _commonDataService: CommonDataService,
    public _emulationService: EmulationService,
    public _switchAdvisor: switchAdvisorService,
  ) {}

  ngOnInit(): void {
    // Subscribe to router events to update isMFAPage after navigation
    // Get the OIDC user from local storage
    this.oidcUser = sessionStorage.getItem('oidc.user:' + OidcConfig.authority + ':' + OidcConfig.client_id);
    if (this.oidcUser && JSON.parse(this.oidcUser)?.access_token) {
      this.loadPageHeader();
      this.getAdvisorList(); // Load the advisor list when authentication is completed
    }
    // Subscribe to the user observable to get the user's name
    this._authorize.getUserObservable().subscribe((user) => {
      this.userName = user?.profile?.preferred_username || user?.profile?.name || '';
    });

    this.inputText = '';

    // Subscribe to the authCompleted$ observable to load the page header when authentication is completed
    this.authCompletedSubscription = this._authorize.authCompleted$.subscribe((authCompleted: boolean) => {
      if (authCompleted) {
        this.loadPageHeader();
        this.getAdvisorList(); // Load the advisor list when authentication is completed
      }
    });
    this.highLightHeaderMenuItem();
    // Listen for route changes to highlight the active menu item
    this.navigationSubscription = this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.highLightHeaderMenuItem();
      });

    // set the flags based on the screen size
    this.checkScreenSize();
  }
  ngAfterViewInit(): void {
    // Subscribe to router events to update isMFAPage after navigation
    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.loginCheck =
        this._router.url.includes('/mfa') ||
        this._router.url.includes('/idp') ||
        this._router.url.includes('/userprofile');
    });
  }
  getAdvisorList() {
    const payload: requestforEmulationPayload = {
      requestingSystem: 'FinPro',
      isEmulating: this.emulatedUser() ? true : false,
      emulatingUserId: this.emulatedUser()?.userId || '',
    };
    this._headerService.getAdvisorList(payload).subscribe({
      next: (_data) => {
        this.advisorList = _data.advisorList || [];
        this.selectAdvisorByDefault();
      },
      error: (_e) => {},
    });
  }
  // Flag to control the visibility of the advisor menu
  showAdvisorMenu = false;

  // Index of the currently selected advisor, or null if none is selected
  selectedAdvisorIndex: number = 0;
  // selectAdvisorByDefault method
  selectAdvisorByDefault() {
    const advisorData: any = this._switchAdvisor.loadswitchedAdvisor();
    if (advisorData && advisorData.advisorId) {
      const index = this.advisorList.findIndex(
        (advisor: { advisorId: any }) => advisor.advisorId === advisorData.advisorId,
      );
      if (index !== -1) {
        this.selectedAdvisorIndex = index;
        this.userName = this.advisorList[index]?.firstName + ' ' + this.advisorList[index]?.lastName || '';
      } else {
        this.selectedAdvisorIndex = 0;
      }
    } else {
      this.selectedAdvisorIndex = 0; // Default to the first advisor if no advisor is selected
    }
  }
  // Selects an advisor by index
  selectAdvisor(index: number) {
    this.selectedAdvisorIndex = index;
    this.userName = this.advisorList[index]?.firstName + ' ' + this.advisorList[index]?.lastName || '';
    if (this.advisorList[index]?.advisorId !== this.currentUserId) {
      const advisorId = this.advisorList[index]?.advisorId || '';
      this._switchAdvisor.switchAdvisor({
        advisorId,
        firstName: this.advisorList[index]?.firstName || '',
        lastName: this.advisorList[index]?.lastName || '',
        accessType: this.advisorList[index]?.accessType || '',
      });
    } else {
      this._switchAdvisor.stopswitchAdvisor();
    }
  }
  // Toggles the visibility of the advisor menu
  toggleAdvisorMenu() {
    this.showAdvisorMenu = !this.showAdvisorMenu;
  }
  // Method to check if the user is emulating another user
  public loadPageHeader(): void {
    const payload: requestforEmulationPayload = {
      requestingSystem: 'FinPro',
      isEmulating: this.emulatedUser() ? true : false,
      emulatingUserId: this.emulatedUser()?.userId || '',
    };
    this._headerService.getNavigationHeader(payload)?.subscribe({
      next: (_data) => {
        if (_data) {
          this.linksResources = _data.header.find((item: any) => item.name === 'Resources')?.links || [];
          this.linksTools = _data.header.find((item: any) => item.name === 'Tools')?.links || [];
          // Set accessDelegation to true if "Delegation" header exists, otherwise false
          this.accessDelegation = !!_data.header.find((item: any) => item.name === 'Delegation');
        }
      },
      error: (_e) => {},
    });
  }

  //Method to to get accord firelight id for form header item
  getAccordFirelightID(target: string): void {
    if (this.checkMFAToken()) {
      this._headerService.getAccordFirelightID()?.subscribe({
        next: (_data) => {
          if (_data) {
            const formUrl = config.accordFireLightFormUrl + `${_data?.firelightSSORefId}`;
            // Navigate to the form page
            window.open(formUrl, target);
          }
        },
        error: (_e) => {},
      });
    } else {
      window.open('/advisor', target);
    }
  }

  navigateToUrl(url: string, target: string): void {
    if (url === '/advisor/tools/forms') {
      this.getAccordFirelightID(target);
    } else {
      this.navigateToUrlBeforeLogin(url);
      if (target === '_blank') {
        // Open in a new tab
        window.open(url, '_blank');
      } else {
        // Navigate in the same tab
        this.resetArrowImage();
        this._router.navigateByUrl(url);
      }
    }
  }

  // Method to toggle the tools submenu
  public toggleSubMenu() {
    this.is_active = 'tools';
    this.toggleMenuState('tools');
    this.flipArrowImage('arrowIcon_T');
    const arrowIcon = document.getElementById('arrowIcon_R');
    if (arrowIcon && arrowIcon.style.transform === 'translateY(-50%) scaleY(-1)') {
      arrowIcon.style.transform = 'translateY(0%) scaleY(1)';
    }
  }

  // Method to toggle the resources submenu
  public toggleSubMenuForResources() {
    this.is_active = 'resources';
    this.toggleMenuState('resources');
    this.flipArrowImage('arrowIcon_R');
    const arrowIcon = document.getElementById('arrowIcon_T');
    if (arrowIcon && arrowIcon.style.transform === 'translateY(-50%) scaleY(-1)') {
      arrowIcon.style.transform = 'translateY(0%) scaleY(1)';
    }
  }
  // Method to toggle the profile submenu
  public toggleSubMenuForProfile() {
    this.is_active = 'profile';
    this.toggleMenuState('profile');
    this.flipArrowImage('arrowIcon_R');
    const arrowIcon = document.getElementById('arrowIcon_T');
    if (arrowIcon && arrowIcon.style.transform === 'translateY(-50%) scaleY(-1)') {
      arrowIcon.style.transform = 'translateY(0%) scaleY(1)';
    }
  }

  // Method to open the search bar
  public openSearchBar() {
    this.toggleMenuState('searchBar');
    this.isHamburgerMenuIconclicked = false;
    this.resetArrowImage();
    this.inputText = '';
    setTimeout(() => {
      if (this.inputSearchField_small?.nativeElement && this.inputSearchField?.nativeElement) {
        this.inputSearchField_small.nativeElement.focus();
        this.inputSearchField.nativeElement.focus();
      }
    }, 1000);
  }

  // Method to toggle the hamburger menu icon
  public toggleHamburgerMenuIcon() {
    this.isHamburgerMenuIconclicked = !this.isHamburgerMenuIconclicked;
    this.isSearchBarOpened = false;
  }

  // Method to toggle the menu state
  public toggleMenuState(caller: 'tools' | 'resources' | 'searchBar' | 'hamburgerMenuIcon' | 'profile') {
    this.isMenuCollapsed = caller === 'tools' ? !this.isMenuCollapsed : false;
    this.isMenuCollapsedForResuorces = caller === 'resources' ? !this.isMenuCollapsedForResuorces : false;
    this.isMenuCollapsedForProfile = caller === 'profile' ? !this.isMenuCollapsedForProfile : false;
    this.isSearchBarOpened = caller === 'searchBar' ? !this.isSearchBarOpened : false;
  }

  onSearchSubmit(inputText: string): void {
    const data = inputText;
    this._commonDataService.setData(data);
    this._router.navigate(['/advisor/search']);
    this.resetArrowImage();
    this.closeSubMenuItemClick('_self');
    this.is_active = '';
  }

  highLightHeaderMenuItem(): void {
    const currentUrl = this._router.url;
    // Determine the active menu item based on the route
    if (currentUrl === '/advisor') {
      this.is_active = 'home';
    } else if (currentUrl.startsWith('/advisor/secure-file-upload')) {
      this.is_active = 'tools';
    } else if (currentUrl.includes('/advisor/resources') || currentUrl.startsWith('/advisor/latest-rates')) {
      this.is_active = 'resources';
    } else if (currentUrl.startsWith('/advisor/contact')) {
      this.is_active = 'contact';
    } else if (
      currentUrl.startsWith('/advisor/profile') ||
      currentUrl.startsWith('/delegate-user') ||
      currentUrl.startsWith('/grant-user') ||
      currentUrl.startsWith('/terms-and-conditions')
    ) {
      this.is_active = 'profile';
    } else if (currentUrl.startsWith('/BOB-Landing')) {
      this.is_active = 'bob';
    } else {
      this.is_active = '';
    }
  }

  // Click listener to close menus if clicked outside, but not inside the submenu
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Check if the click happened inside the specific submenu
    if (target && typeof target.closest === 'function') {
      const isClickInsideSubMenu = target.closest('.fn__primary-nav__sub-menu , .fn__header-search__content');
      const isClickOnMenuButton =
        target.closest('.fn__primary-nav__menu-item') ||
        target.closest('.fn__hamburger-button') ||
        target.closest('.fn__header-search__button');

      // Close the submenus only if clicked outside of the menu or submenu
      if (!isClickInsideSubMenu && !isClickOnMenuButton) {
        this.isMenuCollapsed = false;
        this.isMenuCollapsedForResuorces = false;
        this.isMenuCollapsedForProfile = false;
        this.isSearchBarOpened = false;
        this.resetArrowImage();
      }
    }
  }

  // Method to handle click events on menu items
  setActiveClass(link: any): void {
    this.is_active = link;
    this.isMenuCollapsed = false;
    this.isMenuCollapsedForResuorces = false;
    this.isMenuCollapsedForProfile = false;
    this.isSearchBarOpened = false;
    window.scrollTo(0, 0); // Moves page to top
    this.isHamburgerMenuIconclicked = false;
    this.isSearchBarOpened = false;
  }
  // Prevent closing the submenu if clicked inside the submenu wrapper
  onSubMenuBlockClick(event: MouseEvent): void {
    event.stopPropagation(); // Prevent the body click event from triggering
  }
  // Method to flip the arrow icon
  flipArrowImage(htmTaglId: string) {
    const arrowIcon = document.getElementById(htmTaglId);
    if (arrowIcon) {
      const isFlipped = arrowIcon.style.transform === 'translateY(-50%) scaleY(-1)';
      arrowIcon.style.transform = isFlipped ? 'translateY(0%) scaleY(1)' : 'translateY(-50%) scaleY(-1)';
    }
  }

  resetArrowImage(): void {
    const arrowIconT = document.getElementById('arrowIcon_T');
    const arrowIconR = document.getElementById('arrowIcon_R');
    if (arrowIconT) {
      arrowIconT.style.transform = 'translateY(0%) scaleY(1)';
    }
    if (arrowIconR) {
      arrowIconR.style.transform = 'translateY(0%) scaleY(1)';
    }
  }

  // Method to handle click events on submenu items to hide sub menu block
  closeSubMenuItemClick(target: string): void {
    if (target !== '_blank') {
      this.isMenuCollapsed = false;
      this.isMenuCollapsedForResuorces = false;
      this.isMenuCollapsedForProfile = false;
      this.isHamburgerMenuIconclicked = false;
      this.isSearchBarOpened = false;
      this.resetArrowImage(); // Reset the arrow images when a submenu item is clicked
    }
  }

  getLinksForColumn(column: number): any[] {
    const linksPerColumn = Math.ceil(this.linksTools.length / 3);
    return this.linksTools.slice(column * linksPerColumn, (column + 1) * linksPerColumn);
  }

  navigateToContact(): void {
    this.resetArrowImage();
    this._router.navigate(['/advisor/contact']);
    this.navigateToUrlBeforeLogin('/advisor/contact');
  }

  // Method to handle url redirection while on before login header click
  navigateToUrlBeforeLogin(url: string): void {
    if (this._router.url === '/advisor/mfa/challenge' || this._router.url === '/advisor/mfa') {
      sessionStorage.setItem('RequestedURL', url);
    }
  }

  checkMFAToken(): boolean {
    const name = this.MFALoginKeyName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let c of ca) {
      c = c.trim();
      if (c.indexOf(name) === 0) {
        const encodedToken = c.substring(name.length, c.length);
        try {
          const token = atob(encodedToken);
          return !!token;
        } catch {
          return false;
        }
      }
    }
    return false;
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    this.authCompletedSubscription.unsubscribe();
    this.navigationSubscription.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: Event) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    // Check the window width and set flags accordingly
    const width = window.innerWidth;
    this.windowIsSmall = width < 768;
    this.windowIsLarge = width > 768;
  }
}
